/**
 * In-App Notifications Process Handlers
 *
 * Mutation handlers for marking in-app notifications as viewed
 */

import { httpsCallable } from 'firebase/functions'
import { functions } from '../../libs/Firebase'
import { handleRequest } from './config'
import type { ApiResponse } from '../types'

/**
 * Mark a single notification as viewed
 */
export const markNotificationViewed = async (notificationId: string): Promise<ApiResponse<void>> =>
  handleRequest(
    () => Promise.resolve({ data: undefined, success: true } as ApiResponse<void>),
    async () => {
      const fn = httpsCallable<{ notificationId: string }, { success: boolean }>(functions, 'markNotificationViewed')
      const result = await fn({ notificationId })
      return { data: undefined, success: result.data.success }
    }
  )

/**
 * Mark all notifications as viewed for the current user
 */
export const markAllNotificationsViewed = async (): Promise<ApiResponse<void>> =>
  handleRequest(
    () => Promise.resolve({ data: undefined, success: true } as ApiResponse<void>),
    async () => {
      const fn = httpsCallable<Record<string, never>, { success: boolean }>(functions, 'markAllNotificationsViewed')
      const result = await fn({})
      return { data: undefined, success: result.data.success }
    }
  )
